import { createFileRoute } from "@tanstack/react-router";

import type { WatchGameSessionViewViews } from "~/features/gameSession/components/WatchGameSessionView/watchGameSessionViewTypes.ts";
import WatchGameSessionPage from "~/pages/gameSession/WatchGameSessionPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/watch")({
    validateSearch: (search: Record<string, unknown>): { view?: WatchGameSessionViewViews } => {
        return {
            view: (search.view as WatchGameSessionViewViews) || undefined,
        };
    },
    component: WatchGameSessionPage,
});
